import { SideModal } from "../../../../components/SideModal";
import { BrandAssets } from "../../../../components/BrandAssets";

/**
 * Brand assets for a hotel with NO provisioning pipeline row — the shared
 * BrandAssets panel in a bare drawer. Hotels with a pipeline get the full
 * UserDetailPanel instead (same panel, plus pipeline and actions).
 */
export function BrandAssetsDrawer({
  userId,
  hotelName,
  onClose,
}: {
  userId: string;
  hotelName: string;
  onClose: () => void;
}) {
  return (
    <SideModal onClose={onClose}>
      <div className="fixed z-[3] top-0 right-0 h-[100dvh] w-full max-w-[720px] bg-white shadow-xl overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-border-primary px-6 py-4 flex items-start justify-between z-10">
          <div>
            <div className="font-semibold text-lg text-content-primary">
              Brand assets
            </div>
            <div className="text-xs text-content-secondary">{hotelName}</div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-content-secondary hover:text-content-primary text-2xl leading-none px-2"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="px-6 py-5">
          <BrandAssets userId={userId} />
        </div>
      </div>
    </SideModal>
  );
}
